import {useEffect,useState} from 'react'
//import {UserEditModalHeader} from './UserEditModalHeader'
//import {UserEditModalFormWrapper} from './UserEditModalFormWrapper'
import { ViewModalHeader } from './ViewModalHeader'
import axios from 'axios'
import Swal from 'sweetalert2'
import { useAppSelector } from '../../../../../redux/hooks'
import { useAuth } from '../../../auth'
const API_URL = process.env.REACT_APP_API_URL




const Detail = ( props:any ) => {
  /*********************************Constantes**************************************** */
  const Type = useAppSelector(state => state.CloudSlice.Type)


  return (
    
    <>
    {props.id !==null  && props.detail!==null&& props.detail!==undefined&& props.list!==undefined&&
    <div>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered mw-650px'>
          {/* begin::Modal content */}
          <div className='modal-content'>
            <ViewModalHeader setID={props.setID} />
            {/* begin::Modal body */}
            <div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
            <form className='form w-100' id='kt_login_signin_form'  >
                                {/* begin::Heading */}
                               {/* <Card4
                                icon='/media/svg/files/NubeTD.svg'
                                title=' '
                        description=''></Card4>*/}
                                <div className='text-center mb-5'>
                                <h1 className='text-dark fw-bolder mb-3 f-titulo fs-md'>Edge Connector Detail</h1>
                                </div>
                                {/* begin::Heading */}

                                <div className='row text-center f-parrafo'>
                                   <div className='col'>
                                      <p className='fw-bolder text-pink'>CTX Backbone Status:</p> 
                                      {props.detail.equinixStatus}</div>
                                   <div className='col '>
                                     <p className='fw-bolder text-pink'>Cloud Provider Status:</p> 
                                      {props.detail.providerStatus}
                                   </div>
                                   <div className='col '>
                                     <p className='fw-bolder text-pink'>BGP Status:</p> 
                                      {props.detail.bgpstatus}
                                   </div>
                                </div>
                        
                        <br />
                        <div className='d-flex flex-center'>
                                  <table>
                                    <thead>
                                      <tr className="table-header-light bg-marino">
                                      
                                      </tr>
                                    </thead>

                                    <tbody>
                                    {props.list.map((d:any,i:any)=>(
                                      <tr key={i}>
                                       <td className='table-cell'>{d.connector}</td>

                                       
                                      
                                { d.status===null ? <td className='table-cell'>
                                    <i className="fas bi bi-arrow-down-circle text-pink" style={{fontSize:'24px'}}
                                    data-bs-toggle='tooltip'
                                    title='DOWN'
                                  ></i>
                                  </td>:

                                 d.status==='WARNING' ?<td className='table-cell'>
                                  <i className="bi bi-exclamation-triangle text-warning" style={{fontSize:'24px'}}
                                  data-bs-toggle='tooltip'
                                  title='DOWN'
                                ></i>
                                 
                                </td>:
                                
                              (d.status==='AVAILABLE'||d.status==='PROVISIONED'||d.status==='PROVISIONING'||d.status==='UP') ? <td className='table-cell'><i className="bi bi-check2-circle text-azul " style={{ fontSize: '24px' }} data-bs-toggle='tooltip'
                                    title={d.status}></i>
                                    
                                    
                                    </td>   :   
                               
                                (d.status==='DEPROVISIONED'||d.status==='DEPROVISIONING'|| d.status === 'NOT_AVAILABLE' || d.status === 'FAILED'||d.status==='PENDING_APROVAL'||d.status==='REJECTED'
                                ||d.status==='PENDING_BGP'||d.status==='OUT_OF_BANDWITH'||d.status==='DELETED'||d.status==='ERROR'||d.status==='ERRORED'||d.status==='NOTPROVISIONED'||d.status==='NOT_PROVISIONED'
                                ||d.status==='ORDERING'||d.status==='DELETING'||d.status==='PENDING_DELETE'||d.status==='N/A'||d.status==='DOWN')  ? 
                                  <td className='table-cell'> 
                                    <i className="fas bi bi-arrow-down-circle text-pink" style={{fontSize:'24px'}}
                                    data-bs-toggle='tooltip'
                                    title={d.status}
                                  ></i> 
                                    
                                    
                                  </td>:
                                <td className='table-cell'><i className="fas bi bi-arrow-down-circle text-pink " style={{ fontSize: '24px' }}></i></td>

                                }      


                                      </tr>
                                    ))}
                                    </tbody>
                                  </table>
                                </div>

                              <br />
                              <br />
                               
                                 {/* begin::Action */}
                                 <div className='d-grid mb-10 justify-content-center'>
                                  <div className='row'>
                                      {/*<div className='col'>
                                        <button
                                        type='submit'
                                        id='kt_sign_in_submit'
                                        className='btn btn-primary'                                                                        
                                        >
                                          {!loading && <span className='indicator-label'>Send</span>}
                                          {loading && (
                                            <span className='indicator-progress' style={{display: 'block'}}>
                                            Please wait...
                                              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                            </span>
                                          )}
                                        </button>

                                          </div>*/}
                                      <div className='col'>
                                        <button
                                         className='btn border border-pink text-pink f-parrafo'
                                         style={{width:'200px'}}
                                        onClick={() => props.setID(undefined)}

                                        >
                                          Close
                                        </button>
                                      </div>
                                    
                                  </div>
                                  
                                </div>
                                {/* end::Action */}

                                
                            </form>
                            
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
      </div>
      }
{props.id !==null  && props.detail===undefined&&
    <div>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered mw-650px'>
          {/* begin::Modal content */}
          <div className='modal-content'>
            <ViewModalHeader setID={props.setID} />
            {/* begin::Modal body */}
            <div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
            <form className='form w-100' id='kt_login_signin_form'  >
                                {/* begin::Heading */}
                               {/* <Card4
                                icon='/media/svg/files/NubeTD.svg'
                                title=' '
                        description=''></Card4>*/}
                                <div className='text-center mb-5'>
                                <h1 className='text-dark fw-bolder mb-3 f-titulo fs-md'> No Edge Detail</h1>
                                </div>
                                {/* begin::Heading */}

                                
                        
                        <br />
                               
                                 {/* begin::Action */}
                                 <div className='d-grid mb-10 justify-content-center'>
                                  <div className='row'>
                                      {/*<div className='col'>
                                        <button
                                        type='submit'
                                        id='kt_sign_in_submit'
                                        className='btn btn-primary'                                                                        
                                        >
                                          {!loading && <span className='indicator-label'>Send</span>}
                                          {loading && (
                                            <span className='indicator-progress' style={{display: 'block'}}>
                                            Please wait...
                                              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                            </span>
                                          )}
                                        </button>

                                          </div>*/}
                                      <div className='col'>
                                        <button
                                         className='btn border border-pink text-pink f-parrafo'
                                         style={{width:'200px'}}
                                        onClick={() => props.setID(undefined)}

                                        >
                                          Close
                                        </button>
                                      </div>
                                    
                                  </div>
                                  
                                </div>
                                {/* end::Action */}

                                
                            </form>
                            
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
      </div>
      }



      

    </>
  )
}
export {Detail}